import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { Component } from '@angular/core';

export interface StarsCellRendererParams extends ICellRendererParams {
  value: IStarsRendererParams;
}

export interface IStarsRendererParams {
  max?: number;
  score?: number;
  efficiency?: number;
  blankCellIfNullValues?: boolean;
}

@Component({
    selector: 'app-cell-renderer-stars',
    templateUrl: './cell-renderer-stars.component.html',
    styleUrls: ['./cell-renderer-stars.component.scss'],
    standalone: false
})
export class CellRendererStarsComponent implements AgRendererComponent {
  public max?: number;
  public efficiency?: number;

  public score?: number;
  public blankCellIfNullValues = true;

  public agInit(params: StarsCellRendererParams): void {
    this.getValues(params);
  }

  public refresh(params: StarsCellRendererParams) {
    const { max, score, efficiency } = params.value;
    if (
      this.max !== max ||
      this.score !== score ||
      this.efficiency !== efficiency
    ) {
      return false;
    }

    this.getValues(params);
    return true;
  }

  public shouldShowStars() {
    if (!this.blankCellIfNullValues) {
      return true;
    }
    return this.score !== null && this.score !== undefined;
  }

  private getValues(params: StarsCellRendererParams) {
    this.efficiency = params.value.efficiency;
    this.max = params.value.max;
    this.score = params.value.score;
    this.blankCellIfNullValues =
      params.value.blankCellIfNullValues || this.blankCellIfNullValues;
    this.max = params.value.max;
  }
}
